import keycloakAxios from '@/services/axios';
import {updateMyGroups} from '@/redux-store/slices/groups';
import {store} from '@/redux-store/store';
import {GroupData, GroupFormData} from '@/types/group';
import {emitGroupChangeEvent} from './change-observable';

export const createGroup = async (groupData: GroupFormData, userId: string) => {
  const response = await keycloakAxios.post(`group/`, groupData);

  if (response.status >= 300) {
    throw new Error(
      `Error creating group: Invalid status code: ${response.status}`
    );
  }

  emitGroupChangeEvent({
    type: 'new',
    data: response.data as GroupData
  });

  store.dispatch(updateMyGroups({group: response.data, userId}));
  return response.data;
};
